<template>
  <div class="profile-card">
    <div class="avatar-change-icon">
      <!-- <a-dropdown id="drpdwn" placement="bottomRight" :trigger="['click']">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <div
                  class="camera-icon-btn"
                >
                  <label
                    class="camera-bttn cp d-flex justify-content-center align-items-center d-flex justify-content-center align-items-center"
                    aria-hidden="true"
                    :style="{ background: getPrimaryColor() }"
                  >
                    <font-awesome-icon
                      size="2x"
                      :style="{
                        color: 'white !important',
                        transform: 'scale(0.5)',
                        height: '100%'
                      }"
                      :icon="['fas', 'camera']"
                    />
                  </label>
                </div>
            </a>
            <a-menu  slot="overlay">
              <a-menu-item key="0">
                <span  @click="() => $refs.avatarModal.show()" class="dropdown-text">
                  <font-awesome-icon
                    size="1x"
                    :icon="['fal', 'user-ninja']"
                    class="mr-2"
                  />
                  Create avatar
                </span>
              </a-menu-item>
              <a-menu-item key="1">
                <span class="dropdown-text">
                  <font-awesome-icon
                    size="1x"
                    :icon="['fal', 'images']"
                    class="mr-2"
                  />
                  Select avatar
                </span>
              </a-menu-item>
              <a-menu-item key="2">
                <span class="dropdown-text">
                  <font-awesome-icon
                    size="1x"
                    :icon="['fal', 'arrow-from-bottom']"
                    class="mr-2"
                  />
                  <input
                        class="camera-icon-inp position-absolute"
                        type="file"
                        ref="fileInput"
                        @change="handlePicUpload()"
                        :style="{
                             cursor: 'pointer',
                            left: '29px',
                            top:'69px',
                            opacity: '0',
                            width:'123px'
                        }"
                   />
                  Upload image
                </span>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="3">
                <span class="dropdown-text" @click="handleAavatarRemove">
                  <font-awesome-icon
                    size="1x"
                    :icon="['fal', 'trash']"
                    class="mr-2"
                  />
                  Remove
                </span>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
      <button
        id="menu"
        class="threedot-menu"
        @click="
          () => {
            $refs.drawerRef.isMobile ? $refs.drawerRef.show() : (displayDots3 = !displayDots3)
          }
        "
      >
        <div class="dot-menu-cont">
          <div class="camera-icon-btn">
            <label
              class="camera-bttn cp d-flex justify-content-center align-items-center d-flex justify-content-center align-items-center"
              aria-hidden="true"
              :style="{ background: getPrimaryColor() }"
            >
              <font-awesome-icon size="2x" :style="{ color: 'white !important', transform: 'scale(0.5)', height: '100%' }" :icon="['fas', 'camera']" />
            </label>
          </div>
        </div>
        <div :class="`${displayDots3 ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
          <!-- <p class="card-item" @click="() => $refs.avatarModal.show()">
            <font-awesome-icon size="1x" :icon="['fal', 'user-ninja']" class="mr-2" />
            Create avatar
          </p> -->
          <p
            class="card-item"
            @click="
              () => {
                $refs.profileImageGalleryModal.show()
              }
            "
          >
            <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
            Select avatar
          </p>
          <p class="card-item position-relative">
            <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
            <input
              class="cp camera-icon-inp position-absolute w-100"
              type="file"
              accept="image/png, image/jpeg, image/svg+xml"
              ref="mfile"
              @change="handleMobileProfilePicUpload()"
              :style="{ left: '0px', opacity: '0' }"
              title=""
            />
            Upload image
          </p>
          <p class="divider"></p>
          <p class="card-item" @click="remove()">
            <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
            Remove
          </p>
        </div>
      </button>
    </div>
    <div class="profile-container">
      <div class="avatar-container">
        <a-avatar :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? authUser.user.url : '' ? '' : '#EF8585' }" :size="150" v-if="isFetchingprofileimage">
          <div>
            <div class="spinner-border spinner-class"></div>
          </div>
        </a-avatar>
        <a-avatar
          v-if="!isFetchingprofileimage"
          :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? '' : '#EF8585' }"
          :size="150"
          :src="authUser.user.url"
          class="text-capitalize"
        >
          {{ authUser.user.display_name ? authUser.user.display_name[0] : authUser.user.first_name ? authUser.user.first_name[0] : "D" }}
        </a-avatar>
      </div>
      <div class="options">
        <!-- <a-dropdown placement="bottomRight" :trigger="['click']">
                  <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                    <div>
                       <font-awesome-icon
                        :style="{
                          color:'#94A3B8',
                          height:'24px',
                          width:'6px'
                        }"
                        :icon="['fas', 'ellipsis-v']"
                      />
                    </div>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item key="0">
                      <span
                        class="dropdown-text"
                      >
                      <font-awesome-icon
                        size="1x"
                        :icon="['fal', 'flag']"
                        class="mr-2"
                      />
                        Report
                      </span>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown> -->
        <button id="menu" class="threedot-menu-edited" @click="() => (displayDots2 = !displayDots2)" @blur="() => (displayDots2 = false)">
          <div>
            <font-awesome-icon :style="{ color: '#94A3B8', height: '24px', width: '6px' }" :icon="['fas', 'ellipsis-v']" />
          </div>
          <div :class="`${displayDots2 ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
            <p
              class="card-item"
              @click="
                () => {
                  $refs.ShareProfileModal.showModal()
                }
              "
            >
              <ShareProfileModal ref="ShareProfileModal" />
              <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                <path
                  d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                  fill="black"
                /></svg
              >Share Profile
            </p>
          </div>
        </button>
      </div>
    </div>
    <div class="options-mob">
      <!-- <a-dropdown placement="bottomRight" :trigger="['click']">
                  <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                    <div>
                       <font-awesome-icon
                        :style="{
                          color:'#94A3B8',
                          height:'24px',
                          width:'6px'
                        }"
                        :icon="['fas', 'ellipsis-v']"
                      />
                    </div>
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item key="0">
                      <span
                        class="dropdown-text"
                      >
                      <font-awesome-icon
                        size="1x"
                        :icon="['fal', 'flag']"
                        class="mr-2"
                      />
                        Report
                      </span>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown> -->
      <button id="menu" class="threedot-menu-edited-mob" @click="() => $refs.drawerShareRef.show()">
        <div>
          <font-awesome-icon :style="{ color: '#94A3B8', height: '24px', width: '6px' }" :icon="['fas', 'ellipsis-v']" />
        </div>
      </button>
    </div>
    <div class="username-container" v-if="authUser">
      <span class="username text-capitalize">{{ authUser.user.display_name }} </span>
    </div>
    <div class="location-container" v-if="authUser.user.location && authUser.user.location[0].city">
      <font-awesome-icon size="1x" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'map-marker-alt']" />
      {{ authUser.user.location[0].city }},
      {{ authUser.user.location[0].state }}
    </div>
    <div class="seperator"></div>
    <div class="statistics">
      <div class="circle-mem">
        <span class="num">{{ MembersOnCircles }}</span>
        <span class="num-text">Circle Members</span>
      </div>
      <div class="vertical-seperator"></div>
      <div class="circle-on">
        <span class="num">{{ circlesOn }}</span>
        <span class="num-text">Circle On</span>
      </div>
    </div>
    <div :style="{ 'background-color': getSecondaryColor() }" class="update-instruct-mob">
      <font-awesome-icon size="1x" :style="{ transform: 'scale(1.2)', color: '#FFFFFF' }" :icon="['fas', 'calendar-edit']" />
      <div class="instruct">
        <span class="in1">Update Your DoveDaily</span>
        <span v-if="dovedailyUpdatedAt" class="in2">Last updated: {{ new Date(dovedailyUpdatedAt).toDateString().substring(4) }}</span>
      </div>
      <button id="update" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })" class="update-btn">Update</button>
    </div>
    <div class="seperator"></div>
    <div class="profile-completion-status">
      <div class="profile-header-container">
        <span class="profile-header">Profile Completion</span>
        <span class="edit-button" :style="{ background: getPrimary50Color() }" @click="handleProfileEdit">
          <font-awesome-icon size="1x" :style="{ transform: 'scale(1.2)', color: getPrimaryColor() }" :icon="['fas', 'pen']" />
          <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
        </span>
      </div>
      <div v-if="options.length" class="loader-container">
        <a-progress :key="percentTotal" :percent="percentTotal" class="custom-progress" :strokeColor="getPrimaryColor()" :format="percent => `${percent}%`" />
      </div>
    </div>
    <SimpleLoader v-if="loadingProfC" :name="'profile completeness data'" class="mx-auto" />
    <div class="profile-edit-contanier" v-else>
      <div class="profile-edit-header-container">
        <span class="profile-edit-header">Complete your profile</span>
      </div>

      <!-- <div v-if="options.length">
        <div v-for="(item, index) in options" :key="index">
          <div v-if="item.key_name === 'mini_bio' && item.value" class="sub-profile-edit">
            <font-awesome-icon
              v-if="(profileData && profileData['mini_bio']) || profileData['story']"
              class="green-tick ml-2"
              size="1x"
              :style="{ transform: 'scale(1.2)', color: '#00C853' }"
              :icon="['fas', 'check-circle']"
            />
            <div class="edit-status-info-container">
              <span class="edit-status-info">{{ `${item.display_name} - ${item.value}%` }}</span>
            </div>
          </div>

          <div v-if="item.key_name === 'relationship_status' && item.value" class="sub-profile-edit-even">
            <font-awesome-icon
              v-if="profileData && profileData['relationship_status']"
              class="green-tick ml-2"
              size="1x"
              :style="{ transform: 'scale(1.2)', color: '#00C853' }"
              :icon="['fas', 'check-circle']"
            />
            <div class="edit-status-info-container">
              <span class="edit-status-info">{{ `${item.display_name} - ${item.value}%` }}</span>
            </div>
          </div>

          <div v-if="item.key_name === 'current_situation' && item.value" class="sub-profile-edit">
            <font-awesome-icon
              v-if="profileData && profileData['current_situation']"
              class="green-tick ml-2"
              size="1x"
              :style="{ transform: 'scale(1.2)', color: '#00C853' }"
              :icon="['fas', 'check-circle']"
            />
            <div class="edit-status-info-container">
              <span class="edit-status-info">{{ `${item.display_name} - ${item.value}%` }}</span>
            </div>
          </div>

          <div v-if="item.key_name === 'symptom'" class="sub-profile-edit-even">
            <font-awesome-icon
              v-if="profileData && profileData['symptom'] && profileData['symptom'].length"
              class="green-tick ml-2"
              size="1x"
              :style="{ transform: 'scale(1.2)', color: '#00C853' }"
              :icon="['fas', 'check-circle']"
            />
            <div class="edit-status-info-container">
              <span class="edit-status-info">{{ `${item.display_name} - ${item.value}%` }}</span>
            </div>
          </div>

          <div v-if="item.key_name === 'treatment'" class="sub-profile-edit">
            <font-awesome-icon
              v-if="profileData && profileData['treatment'] && profileData['treatment'].length"
              class="green-tick ml-2"
              size="1x"
              :style="{ transform: 'scale(1.2)', color: '#00C853' }"
              :icon="['fas', 'check-circle']"
            />
            <div class="edit-status-info-container">
              <span class="edit-status-info">{{ `${item.display_name} - ${item.value}%` }}</span>
            </div>
          </div>
        </div>
      </div> -->

      <div v-if="options.length">
        <div v-for="(item, index) in options" :key="index">
          <div :class="`${index % 2 === 0 ? 'sub-profile-edit' : 'sub-profile-edit-even'}`">
            <font-awesome-icon class="green-tick ml-2 font20 success500" :icon="['fas', 'check-circle']" v-if="item.done" />
            <div class="edit-status-info-container">
              <span class="edit-status-info">{{ `${item.display_name} - ${item.value}%` }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="sub-profile-edit">
        <div class="edit-status-info-container-last">
          <span v-if="options.length" class="edit-status-info">
            Other conditions - 5%
          </span>
        </div>
      </div>
      <div class="sub-profile-edit">
        <div class="edit-status-info-container-last">
          <span v-if="options.length" class="edit-status-info">
            <font-awesome-icon
              v-if="profileData && profileData.user && profileData.user[0].url"
              class="green-tick"
              size="1x"
              :style="{ transform: 'scale(1.2)', color: '#00C853' }"
              :icon="['fas', 'check-circle']"
            />
            Create avatar - 5%
          </span>
        </div>
      </div>
      <div class="sub-profile-edit-even">
        <div class="edit-status-info-container-last">
          <span v-if="options.length" class="edit-status-info">
            <font-awesome-icon v-if="MembersOnCircles" class="green-tick" size="1x" :style="{ transform: 'scale(1.2)', color: '#00C853' }" :icon="['fas', 'check-circle']" />
            Add people to your circle - 5%
          </span>
        </div>
      </div>
       -->
      <div :style="{ 'background-color': getSecondaryColor() }" class="update-instruct">
        <font-awesome-icon size="1x" :style="{ transform: 'scale(1.2)', color: '#FFFFFF' }" :icon="['fas', 'calendar-edit']" />
        <div class="instruct">
          <span class="in1">Update Your DoveDaily</span>
          <span v-if="dovedailyUpdatedAt" class="in2">Last updated: {{ new Date(dovedailyUpdatedAt).toDateString().substring(4) }}</span>
        </div>
        <button id="docedaily" :style="{ 'background-color': getPrimaryColor() }" @click="() => $router.push({ name: 'UpdateDoveDaily' })" class="update-btn">Update</button>
      </div>
    </div>
    <AvatarModal ref="avatarModal" :handleProfilePic="handleProfilePic" />
    <ProfileImageGalleryVue :handleLoader="handleLoader" ref="profileImageGalleryModal" />
    <DrawerModal ref="drawerRef">
      <div @click="() => $refs.drawerRef.close()">
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.profileImageGalleryModal.show()
            }
          "
        >
          <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
          Select avatar
        </p>
        <p class="drawer-item position-relative">
          <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
          <input
            class="cp camera-icon-inp position-absolute w-100"
            type="file"
            accept="image/png, image/jpeg, image/svg+xml"
            ref="mfile"
            @change="handleMobileProfilePicUpload()"
            :style="{ left: '0px', opacity: '0' }"
            title=""
          />
          Upload image
        </p>
        <p class="divider w-100 m-0"></p>
        <p class="drawer-item" @click="remove()">
          <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
          Remove
        </p>
      </div>
    </DrawerModal>
    <DrawerModal ref="drawerShareRef">
      <div class="pb-2" @click="() => $refs.drawerShareRef.close()">
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.ShareProfileModal.showModal()
            }
          "
        >
          <ShareProfileModal ref="ShareProfileModal" />
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            /></svg
          >Share Profile
        </p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import AvatarModal from "../Modals/UserAvatarCreationModal.vue"
import s3Upload from "../../utilities/imageUploader"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import BackgroundImageGallery from "../Modals/BackgroundImageGallery.vue"
import ProfileImageGalleryVue from "../Modals/ProfileImageGallery.vue"
import ShareProfileModal from "../Modals/ShareProfileModal.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faPen } from "@fortawesome/pro-solid-svg-icons"
import { faExclamationSquare } from "@fortawesome/pro-solid-svg-icons"
import { faCalendarEdit } from "@fortawesome/pro-solid-svg-icons"
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons"
import { faEllipsisV } from "@fortawesome/pro-regular-svg-icons"
import { faFlag, faUserNinja, faImages, faArrowFromBottom, faTrash } from "@fortawesome/pro-light-svg-icons"
import { List } from "ant-design-vue"
import { mapGetters } from "vuex"
import SimpleLoader from "./SimpleLoader.vue"
import DrawerModal from "../Modals/DrawerModal.vue"

library.add(faEllipsisV, faCheckCircle, faPen, faCalendarEdit, faExclamationSquare, faFlag, faUserNinja, faImages, faArrowFromBottom, faTrash)
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "ProfileCompleteness",
  data() {
    return {
      loadingProfC: false,
      miniBio: false,
      relationStatus: false,
      workStatus: false,
      expandIconPosition: "right",
      userInfo: null,
      imageAva: null,
      displayDots3: false,
      displayDots2: false,
      backgroundImages: [],
      isFetchingprofileimage: false,
      percentTotal: 0,
      profileData: {},
      dovedailyUpdatedAt: null,
      // optionalOptions: [
      //   { display_name: "What inspires me", done: false, key_name: "what_inspires_me", value: "0" },
      //   { display_name: "How would I like the world to change", done: false, key_name: "how_would_i_like_the_world_to_change", value: "0" },
      //   { display_name: "What matters to me the most", done: false, key_name: "what_matters_to_me_the_most", value: "0" },
      //   { display_name: "My favourite places to visit", done: false, key_name: "my_favourite_places_to_visit", value: "0" },
      // ],
      options: [],
    }
  },

  props: {
    // options: List,
    circlesOn: Number,
    MembersOnCircles: Number,
  },

  components: {
    ShareProfileModal,
    AvatarModal,
    BackgroundImageGallery,
    ProfileImageGalleryVue,
    SimpleLoader,
    DrawerModal,
  },

  async created() {
    console.warn("ProfileCompleteness.vue created")
    window.addEventListener("mouseup", () => {
      if (this.displayDots2) {
        setTimeout(() => {
          this.displayDots2 = false
        }, 100)
      }
      if (this.displayDots3) {
        setTimeout(() => {
          this.displayDots3 = false
        }, 100)
      }
    })
    // this.setAppLoaderStatus(true)
    await this.Completeness()
    // this.setAppLoaderStatus(false)
    if (this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver") {
      try {
        const response = await UserRepository.getDovedaily(this.currentCircle.id)
        this.dovedailyUpdatedAt = response.data.data[0] && response.data.data[0].last_updated_at
      } catch (e) {
        console.log(e)
      }
    }
  },

  computed: {
    ...mapGetters({ percent: "Posts/percent", circleDiseaseTypes: "Circle/circleDiseaseTypes" }),
  },

  watch: {
    percent(v) {
      if (v) {
        this.Completeness()
        this.$store.commit("Posts/setPercent", false)
      }
    },
  },

  methods: {
    async Completeness() {
      try {
        this.loadingProfC = true

        // console.warn("Completeness()")
        this.options = []
        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }

        const resData = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
        this.profileData = resData.data.data ? resData.data.data[0] : {}
        console.log("Completeness() -> getAbout -> profileData:", this.profileData)

        const res = await this.$http.get(`${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "normaluser" : "caregiver"}profilecompletion/?circle_id=${this.currentCircle.id}`, {
          headers,
        })
        this.options = res.data.data.filter(option => option.key_name !== "disease_type") || []
        this.percentTotal = res.data.message || 0

        // console.log("profileData.disease_type:", this.profileData.disease_type)
        // console.log("circleDiseaseTypes:", this.circleDiseaseTypes)

        this.options = this.options.map(data => {
          if (data.key_name === "circle") {
            return { ...data, done: !!this.authUser.user.no_of_members }
          } else if (data.key_name === "file_name") {
            return { ...data, done: !!this.authUser.user.url }
          } else if (["gender", "display_name", "location"].includes(data.key_name)) {
            return { ...data, done: true }
          // } else if (data.key_name === "disease_type") {
          //   return { ...data, done: this.profileData.disease_type }
            // return { ...data, done: this.profileData.disease_type || !this.circleDiseaseTypes.length }
          } else if (Array.isArray(this.profileData[data.key_name])) {
            return { ...data, done: !!this.profileData[data.key_name].length }
          } else {
            return { ...data, done: !!this.profileData[data.key_name] }
          }
        })

        // this.optionalOptions = this.optionalOptions.map(option => ({ ...option, done: !!this.profileData[option.key_name] }))

        // this.options = [...this.options, ...this.optionalOptions]
        this.loadingProfC = false
      } catch (e) {
        this.loadingProfC = false
      }
    },

    handleLoader(value) {
      this.isFetchingprofileimage = value
    },

    async remove() {
      console.log("remove()")
      this.isFetchingprofileimage = true
      const payload = { file_name: null }
      try {
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        this.isFetchingprofileimage = false
        this.$store.commit("Posts/setPercent", true)
        this.$notification.success({ message: "Success", description: "Image removed successfully" })
      } catch (err) {
        this.isFetchingprofileimage = false
      }
    },

    onLoadHandler: function() {
      this.isFetchingprofileimage = false
    },

    async handleProfilePic(svgPic) {
      var svgElement = svgPic

      // Create your own image
      var img = document.createElement("img")

      // Serialize the svg to string
      var svgString = new XMLSerializer().serializeToString(svgElement)

      // Remove any characters outside the Latin1 range
      var decoded = unescape(encodeURIComponent(svgString))

      // Now we can use btoa to convert the svg to base64
      var base64 = btoa(decoded)

      var imgSource = `data:image/svg+xml;base64,${base64}`
      this.imageAva = imgSource
      this.handleProfilePicUpload(imgSource)
    },

    async handleProfilePicUpload(img) {
      console.log("handleProfilePicUpload()")
      this.isFetchingprofileimage = true
      const file = this.authUser.user.id + Date.now().toString() + ".svg"
      try {
        const urlPayload = { file_name: [file] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          return new File([u8arr], filename, { type: mime })
        }
        let fileData = dataURLtoFile(img, file)
        await s3Upload(urlData.data.data.url[0], fileData)
        const payload = { file_name: urlData.data.data.filename[0] }
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        this.isFetchingprofileimage = false
        this.$store.commit("Posts/setPercent", true)
      } catch (err) {
        this.isFetchingprofileimage = false
      }
    },

    mainContentNavigation(key) {
      switch (key) {
        case "post":
          this.$router.push({ name: "ActivityHome" })
          break
        case "treatment":
          this.$router.push({ name: "PatientTreatments" })
          break
        case "circle":
          this.$router.push({ name: "patientCirlceSelf" })
          break
        default:
          this.$router.push({ name: "PatientAbout" })
          break
      }
    },

    handleProfileEdit() {
      this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/about` })
    },

    async handleMobileProfilePicUpload() {
      console.log("handleMobileProfilePicUpload() is called")
      this.isFetchingprofileimage = true
      const file = this.$refs.mfile.files[0]
      try {
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image.",
          })
          this.isFetchingprofileimage = false
          return
        }
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        await s3Upload(urlData.data.data.url[0], file)
        const payload = { file_name: urlData.data.data.filename[0] }
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        this.isFetchingprofileimage = false
        this.$notification.success({ message: "Success", description: "Image uploaded successfully" })
      } catch (err) {}
    },
  },
}
</script>

<style>
.custom-progress .any-progress-line {
  font-size: 20px;
}

.custom-progress .ant-progress-text {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  color: #647490;
}
</style>

<style lang="scss" scoped>
.options-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
    justify-content: flex-end;
    margin-right: 40px;
    margin-top: -45px;
    width: 100%;
    cursor: pointer;
  }
}
.divider {
  width: 171px;
  height: 0px;
  border: 0.5px solid #e2e8f0;
  background-color: #e2e8f0;
  margin-left: 16px;
  margin-right: 16px;
}
.card-item {
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-left: 0 !important ;
  line-height: 32px;
  color: #1e2945;
}
.camera-icon-btn {
  .camera-bttn {
    border: 1px solid #f8fafd;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    i {
      vertical-align: bottom;
      color: #fff !important;
    }
    input {
      opacity: 0;
      width: 100%;
    }
  }
}
.profile-bg {
  .camera-btn {
    position: absolute;
    bottom: -9%;
    right: 8vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.divider {
  margin-bottom: 5px;
  width: 171px;
  height: 0px;
  border: 1px solid #e2e8f0;
}

.profile-header-container {
  display: flex;
  // gap: 75px;
  width: 100%;
  justify-content: space-between;
}

.dropdown-text {
  font-weight: 500;
  font-size: 16px;
  padding: 10px 20px;
  color: #333333;
  line-height: 24px;
}

.update-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  width: 72px;
  height: 36px;
  text-transform: capitalize;
  color: #ffffff;
  // background: #2A71D4;
  border-radius: 6px;
  border: none;
}
.in2 {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height, or 117% */

  /* Shades/ White */

  color: #ffffff;
}
.in1 {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* Shades/ White */

  color: #ffffff;
}

.instruct {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 191px;
  // height: 38px;
}
.update-instruct {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 8px;
  width: 335px;
  height: 70px;
  // background: #062B54;
  border-radius: 4px;
  margin-top: 16px;
  @media screen and (max-width: 700px) {
    width: 100%;
    display: none;
  }
}

.update-instruct-mob {
  display: none;
  @media screen and (max-width: 700px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px;
    gap: 8px;
    height: 70px;
    border-radius: 4px;
    margin-top: 16px;
    justify-content: center;
  }
}

.avatar-change-icon {
  z-index: 1;
  position: absolute;
  top: 33px;
  left: 232px;
  cursor: pointer;
  @media screen and (max-width: 700px) {
    // top: 108px;
    // left: 248px;

    position: relative;
    top: 150px;
    left: 50px;
  }
}

.tabs:hover {
  color: #2a71d4;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;

  height: 48px;

  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #0f1734;
}

.profile-tab {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  position: absolute;
  width: 732px;
  height: 48px;
  left: 520px;
  top: 489px;
  @media screen and (max-width: 700px) {
    top: 1280px;
    left: 20px;
    overflow-x: scroll;
  }
}

.profile-tab::-webkit-scrollbar {
  @media screen and (max-width: 700px) {
    width: 0 !important;
  }
}

.edit-status-info-container-last {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 40px;
  padding-left: 8px;
}

.profile-edit-header {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.profile-edit-contanier {
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.profile-edit-header-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 334px;
  height: 40px;
}

.button-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  // color: #2A71D4;
  cursor: pointer;
}

.edit-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 10px;
  width: 80px;
  height: 32px;
  // color: #2A71D4;
  // background: #E1EAF7;
  border-radius: 8px;
  // @media screen and (max-width: 700px) {
  //   display: none;
  // }
}

.edit-status-info-container {
  align-items: flex-start;
  padding: 8px;
  gap: 10px;
  // width: 214px;
  height: 40px;
}

.edit-status-info {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
  gap: 10px;
  display: flex;
}

.green-tick {
  width: 20px;
  height: 20px;
}

.sub-profile-edit-even {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  background: #f1f5f9;
  width: 334px;
  height: 56px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.sub-profile-edit {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;

  width: 334px;
  height: 56px;
}

.profile-completion-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 11px;
  width: 335px;
  height: 60px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

/* 
.custom-progress .ant-progress-outer{
padding: 0px !important;
} */

// .custom-progress .any-progress-line{
//   font-size: 20px;
// }

// .custom-progress .ant-progress-text{
//   font-style: normal;
//   font-weight: 700;
//   font-size: 20px;
//   line-height: 30px;
//   text-align: right;
//   color: #647490;
// }

// .custom-progress .ant-progress-bg{
//   background-color: #2A71D4;
// }

.profile-header {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #33415f;
}

.percentage-indicator {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  width: 40px;
  height: 30px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  color: #647490;
}

.loader-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 335px;
  height: 30px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.seperator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;
  width: 335px;
  height: 16px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.location-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.location-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0px;
  width: 100%;
  justify-content: flex-start;
  height: 24px;
}

.username {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 46px;
  color: #0f1734;
}

.username-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  // width: 335px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.options {
  width: 6px;
  height: 24px;
  cursor: pointer;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.avatar {
  width: 160px;
  height: 160px;
  cursor: pointer;
}

.avatar-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 309px;
  height: 160px;
}

.profile-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0px;

  width: 315px;
  height: 160px;
}

.profile-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 335px;
  height: 1120px;
  @media screen and (max-width: 700px) {
    position: relative;
    top: 64px;
    align-items: center;
    width: 100%;
  }
}

.profile-card-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  height: 1168px;
  left: 120px;
  top: 337px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.banner-image {
  position: absolute;
  width: 1440px;
  height: 400px;
  left: 0px;
  top: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ProfileCompleteness.vue